import React from 'react'
import Header from '../components/Customer/Header'
import Sidebar from '../components/Customer/Sidebar'

const CustomerLayout = () => {
  return (
    <div>
      <Header />
      <Sidebar />
    </div>
  )
}

export default CustomerLayout
